export default "__VITE_ASSET__B_p_jCSe__"